<!-- TranslatedText.vue -->
<script setup>
import { h, useSlots } from 'vue'

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
})

const slots = useSlots()

function renderText() {
  const parts = []
  let lastIndex = 0
  const regex = /{([^}]+)}/g
  let match

  while ((match = regex.exec(props.text)) !== null) {
    // Add text before the placeholder
    if (match.index > lastIndex) {
      parts.push(props.text.substring(lastIndex, match.index))
    }

    // Add the slot content if it exists
    const slotName = match[1]
    if (slots[slotName]) {
      parts.push(h('span', {}, slots[slotName]()))
    } else {
      // If no slot provided, keep the placeholder
      parts.push(`{${slotName}}`)
    }

    lastIndex = match.index + match[0].length
  }

  // Add any remaining text
  if (lastIndex < props.text.length) {
    parts.push(props.text.substring(lastIndex))
  }

  return parts
}
</script>

<template>
  <span>
    <template v-for="(part, index) in renderText()" :key="index">
      <template v-if="typeof part === 'string'">{{ part }}</template>
      <component :is="part" v-else />
    </template>
  </span>
</template>
